export default __webpack_public_path__ + "static/media/icon_arrow.52e5c29f.png";